export default {
  "content": "<path fill=\"#BB2E12\" d=\"M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm-.938 5.938A.94.94 0 0110 5a.94.94 0 01.938.938v5a.938.938 0 01-1.876 0v-5zM10 15.624a1.228 1.228 0 110-2.457 1.228 1.228 0 010 2.457z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "fill": "none",
    "viewBox": "0 0 20 20"
  }
};